import { useEffect, useRef } from 'react'
import styles from './Downloads.module.scss'
import useHubSpotGenerate from 'hooks/useHubSpotGenerate'
import LeftContents from './LeftContents'
import { LeftContentDataType } from './types/types'
import { gsap, Power4 } from 'gsap'
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger'
import MailmagazineLink from 'components/mailmagazine/MailmagazineLink/MailmagazineLink'

gsap.registerPlugin(ScrollTrigger)

const leftContentData: LeftContentDataType = {
  titleVol: <>AI時代の開発フレームワーク戦略</>,
  alt: 'AI時代の開発フレームワーク戦略',
  readText: (
    <>
      複雑なドメインに強いRDRA/DDD、SDDの活用方法を徹底解説。人材不足・コスト課題を解決し、品質・スピードを向上させます
    </>
  ),
  imgLarge: '/images/img/download/framework-strategy/thumbnail_framework_strategy.webp',
  imgCapture: '/images/img/download/framework-strategy/capture_framework_strategy.webp',
  firstContentTitle: 'このような方におすすめ',
  firstHalf: (
    <>
      開発における人材不足や開発コストの課題を解決したい経営層・IT部門責任者。特に、複雑な大規模案件に強いRDRA/DDDや、高品質なAPI開発に有効なSDDなど、フレームワークをAI駆動開発と組み合わせ、開発効率のゲームチェンジャーとなる戦略（工期・品質・成功率に圧倒的な差）を求めている方に最適です。
    </>
  ),
  secondContentTitle: 'この資料でわかること',
  secondHalf1: 'AIの使い方で開発成果に圧倒的な差が生まれる—乗り遅れるリスクと対策',
  secondHalf2: '「とりあえずアジャイル」が失敗を招く—案件に合ったフレームワークの選び方',
  secondHalf3: '大規模開発で要件漏れ・手戻りが起きる原因と、AIで防ぐ仕組み',
  secondHalf4: 'BtoB・API連携の納期を半減させる、仕様駆動×AI自動化の具体的プロセス',
  secondHalf5: '要件定義がUI設計に直結—認識齟齬と手戻りをなくす一気通貫アプローチ',
}

const DownloadAIDrivenDevelopment: React.FC = () => {
  const title_category = useRef<HTMLSpanElement>(null)
  const title_page = useRef<HTMLSpanElement>(null)
  useHubSpotGenerate('na1', '9395227', 'e5f848b3-835b-4776-85c7-dab8f7aa04b3', '#hbspt')
  useEffect(() => {
    gsap.set([title_category.current, title_page.current, `.${styles.read_text}`, `.${styles.section}`], {
      opacity: 0,
      y: 50,
    })

    const timeline = gsap.timeline({
      defaults: {
        opacity: 0,
        y: 50,
        duration: 1,
        ease: Power4.easeOut,
      },
    })

    const commonTo = { opacity: 1, y: 0 }

    timeline
      .to(title_category.current, commonTo, 0.2)
      .to(title_page.current, commonTo, 0.5)
      .to(`.${styles.read_text}`, commonTo, 0.8)
      .to(`.${styles.section}`, commonTo, 1.1)
  }, [])

  return (
    <article className={`${styles.main} downloadArea`}>
      <section className={styles.contents}>
        <h1 className={styles.ttl}>
          <span ref={title_category}>Download</span>
          <span ref={title_page}>{leftContentData.titleVol}</span>
        </h1>
        <p className={styles.read_text}>{leftContentData.readText}</p>
        <section className={styles.section}>
          <LeftContents leftContentData={leftContentData} isSecondContent={true} />
          <div className={styles.content}>
            <div className={styles.title_group}>
              <p className={styles.whitepaper}>
                ご入力いただいたメールアドレス宛に、資料ダウンロード用URLを送付いたします。
              </p>
              <p className={styles.notice}>※ 全ての項目をご入力ください。</p>
            </div>
            <div id="hbspt"></div>
          </div>
        </section>
      </section>
      <MailmagazineLink />
    </article>
  )
}

export default DownloadAIDrivenDevelopment
